// Vinhedo Luxo: o JS da loja inteira. Funções puras em cima (testadas por
// testes/logica.test.mjs, no node); ligação com a página embaixo, só no navegador.

/** O que a página mostra depois de escolher (ou não) um tamanho.
 *  estado: 'pronta' | 'encomenda' | 'indisponivel' | null (nada escolhido).
 *  t: textos do locale (pronta, encomenda, indisponivel, escolha, adicionar). */
export function escolherTamanho(estado, t) {
  if (estado === 'pronta' || estado === 'encomenda') return { linha: t[estado], rotulo: t.adicionar, acao: 'comprar' };
  if (estado === 'indisponivel') return { linha: t.indisponivel, rotulo: t.indisponivel, acao: 'nenhuma' };
  return { linha: '', rotulo: t.escolha, acao: 'escolher' };
}

/** Número de WhatsApp só com dígitos e com o 55 do Brasil. */
export function numeroWhatsapp(n) {
  const d = String(n).replace(/\D/g, '');
  return d.length <= 11 ? `55${d}` : d;
}

/** Link do "Falar com consultor". modelos: { com, sem } com {produto}, {tamanho}, {encomenda} e {url}.
 *  {produto} leva " (cor)" só se a cor existe e o nome ainda não a contém; {encomenda} vira " (encomenda)" ou nada. */
export function linkWhatsapp(numero, modelos, { produto, cor, tamanho, encomenda, url }) {
  const peca = cor && !produto.toLowerCase().includes(cor.toLowerCase()) ? `${produto} (${cor})` : produto;
  const dados = { produto: peca, tamanho: tamanho || '', encomenda: encomenda ? ' (encomenda)' : '', url };
  const texto = (tamanho ? modelos.com : modelos.sem).replace(/\{(produto|tamanho|encomenda|url)\}/g, (_, k) => dados[k]);
  return `https://wa.me/${numeroWhatsapp(numero)}?text=${encodeURIComponent(texto)}`;
}

/** Desconto do Pix em centavos, como o checkout da Shopify calcula o "8% No PIX" do app Scala: o % sobre o valor, com
 *  os centavos cortados (R$ 1.194,57 dá R$ 95,56, não 95,57; R$ 3.583,71 dá R$ 286,69, conferido no checkout em 19/10). */
const descontoPix = (centavos, pct) => Math.floor(centavos * pct / 100);

/** Pix em centavos: preço da variante (decimal, "1194.57", como a busca preditiva devolve) menos o desconto do Pix,
 *  a mesma conta do checkout (1194.57 com 8% dá 109901: o checkout cobra R$ 1.099,01; com o cartão = Pix ÷ 0,92 e o
 *  centavo pra baixo, 1194.56, volta o Pix redondo de 109900). */
export function pixCentavos(preco, pct) {
  const c = Math.round(Number(preco) * 100);
  return c - descontoPix(c, pct);
}

/** Totais da sacola (Tarefa 18b), a mesma conta do snippets/vl-gaveta-corpo.liquid. total: cart.total_price; subtotal:
 *  cart.items_subtotal_price (depois do desconto de produto); pixAplicado: o que o desconto do app Scala já tirou do
 *  total (ele entra no carrinho quando a pessoa clica no botão do Pix; 0 sem ele). O checkout tira os 8% do subtotal das
 *  peças em paralelo com o cupom (os dois sobre o mesmo subtotal). Cartão: o total sem o Pix (com o cupom). Pix: o que o
 *  checkout cobra pelo botão do Pix. Com ou sem o desconto do Scala no carrinho, os números são os mesmos: os 8% nunca
 *  entram duas vezes. Com mais de uma linha, o corte dos centavos é no subtotal, não por linha (checkout de 19/10: 2 x
 *  119457 deu 19113 de desconto, não 9556 + 9556). */
export function totaisSacola({ total, subtotal, pixAplicado = 0, pct }) {
  const cartao = total + pixAplicado;
  const desconto = Math.min(pixAplicado || descontoPix(subtotal, pct), cartao); // o Pix nunca abaixo de zero
  return { cartao, pix: cartao - desconto, desconto };
}

/** R$ como o money_without_trailing_zeros da Shopify: inteiro sem ",00"; com centavos, os centavos aparecem. */
export function reais(c) {
  const inteiro = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `R$ ${inteiro}${c % 100 ? `,${String(c % 100).padStart(2, '0')}` : ''}`;
}

/** URL da busca preditiva da Shopify em JSON (base = routes.predictive_search_url + ".json"): só produtos, até 6. */
export function urlBusca(base, q) {
  return `${base}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
}

/** Textos do script[data-vl-textos] (o JSON do locale). Sem o script, ou com JSON quebrado, devolve null: o JS não liga
 *  o formulário e ele fica nativo (o botão sai ligado do Liquid; os rádios required seguram o envio sem tamanho; o
 *  POST vai pro /cart/add). Nunca lança TypeError. el: o elemento (ou null). */
export function lerTextos(el) {
  try {
    const t = el ? JSON.parse(el.textContent) : null;
    return t && typeof t === 'object' ? t : null;
  } catch {
    return null;
  }
}

/** Abas: pra qual aba a tecla leva (setas dão a volta, Home e End vão às pontas). -1 = tecla que não mexe nas abas. */
export function abaPelaTecla(i, tecla, n) {
  const j = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: n - 1 }[tecla];
  return j === undefined ? -1 : (j + n) % n;
}

/** Carrossel da home (leque dos feedbacks): distância do item j até o da frente, dando a volta.
 *  0 = frente, positivo à direita, negativo à esquerda; a metade de trás vai pela esquerda. O Liquid da seção
 *  vl-feedbacks faz a mesma conta com a frente no 0, pro desenho sem JS ser igual. */
export function posicao(j, frente, n) {
  const k = (j - frente + n) % n;
  return k > n / 2 ? k - n : k;
}

/** Corpo do /cart/change.js pra tirar uma linha da sacola: pela chave da linha (item.key), nunca pela posição. */
export function pedidoRemover(chave) {
  return { id: String(chave), quantity: 0 };
}

/** Corpo do /cart/change.js do menos e do mais da sacola (Tarefa 18c): a quantidade atual mais o passo (-1 ou 1), entre 1
 *  (abaixo disso é o Remover) e o teto por linha (o qtd_max do vl-gaveta-item, que chega pelo data-vl-max). Linha que
 *  passou do teto pela página do produto desce pro teto no menos. atual e teto podem vir como texto (dataset). */
export function pedidoQuantidade(chave, atual, passo, teto) {
  const t = Number(teto) > 0 ? Number(teto) : Infinity; // teto vazio ou estragado não pode virar 0 (zero tira a peça)
  return { id: String(chave), quantity: Math.max(1, Math.min(t, Number(atual) + passo)) };
}

/** Pop-up do Private Club, o antigo Grupo VIP (pedido do dono, 17/10): abre sozinho agora? agora em ms; registro é o que ficou guardado da
 *  última vez, { motivo: 'fechou' | 'entrou', em: ms }: fechou, volta em 7 dias; entrou no grupo, em 180. Sem registro,
 *  ou com registro estragado (motivo desconhecido, data que não é número ou que está no futuro), abre. */
const VIP_DIAS = { fechou: 7, entrou: 180 };
export function vipDeveAbrir(agora, registro) {
  const passou = agora - registro?.em;
  return !(passou >= 0 && passou < VIP_DIAS[registro?.motivo] * 864e5); // NaN (motivo ou data ruim) cai no abre
}

if (typeof document !== 'undefined') {
  // Cabeçalho (Tarefa 16a). Vem primeiro: um erro mais embaixo (produto, sacola) não deixa a página sem menu.
  // Diálogos: [data-abre] abre o <dialog> pelo id e fecha antes o que estiver aberto (a gaveta do menu abre a busca).
  // Fechar é nativo: form method="dialog", Esc e closedby="any"; o foco volta sozinho pro botão que abriu.
  const calmo = matchMedia('(prefers-reduced-motion: reduce)');
  const nivel = (s, on) => {
    s.classList.toggle('is-on', on);
    document.querySelector(`[data-nivel="${s.id}"]`)?.setAttribute('aria-expanded', on);
  };
  // Na captura, antes do clique da Tarefa 15: a sacola dentro da gaveta do menu fecha a gaveta antes de abrir a sua.
  document.addEventListener('click', e => { e.target.closest('[data-vl-abrir-gaveta]')?.closest('dialog')?.close(); }, true);
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-abre]');
    const d = b && document.getElementById(b.dataset.abre);
    if (d) {
      b.closest('dialog')?.close();
      for (const s of d.querySelectorAll('.vl-gmenu__nivel.is-on')) { // reabre no primeiro nível, sem animar
        s.style.transition = 'none';
        nivel(s, false);
        void s.offsetWidth;
        s.style.transition = '';
      }
      d.showModal();
      return;
    }
    // Gaveta do celular: a categoria desce um nível, Voltar sobe; o foco acompanha.
    const n = e.target.closest('[data-nivel]');
    const sn = n && document.getElementById(n.dataset.nivel);
    if (sn) {
      const g = n.closest('dialog');
      if (g) g.scrollTop = 0;
      nivel(sn, true);
      sn.querySelector('[data-voltar]')?.focus({ preventScroll: true });
    }
    const s = e.target.closest('[data-voltar]')?.closest('.vl-gmenu__nivel');
    if (s) {
      nivel(s, false);
      document.querySelector(`[data-nivel="${s.id}"]`)?.focus({ preventScroll: true });
    }
  });
  // Clique fora no Safari (closedby ainda não chegou lá): o clique no fundo cai no próprio <dialog>, fora da caixa.
  for (const d of document.querySelectorAll('dialog[closedby="any"]')) {
    d.addEventListener('click', e => {
      const r = d.getBoundingClientRect();
      if (e.target === d && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) d.close();
    });
  }

  // Pop-up do Private Club (Tarefa 20b, pedido do dono em 17/10; muda a seção 6 do spec, que não tinha pop-up de entrada).
  // Abre onde o <dialog> existe (fora da página de produto e da sacola, /cart), menos no editor de tema. Na home, abre
  // sozinho 1,2 s depois da carga, como o dono pediu (3 s até 20/10; o topo é maior que a foto do pop-up). Nas outras páginas, os 1,2 s
  // contam da primeira rolagem, toque ou tecla: a interação encerra o LCP, e a foto do pop-up não vira o maior
  // elemento da página. Com outro diálogo ou painel aberto (sacola, menu, busca, filtros), ou com a aba escondida,
  // espera fechar ou voltar e tenta mais uma vez só. Fechou (X, Perder essa oportunidade, Esc, clique fora): 7 dias sem abrir
  // sozinho; clicou pra entrar no grupo (no pop-up, no menu ou no rodapé, em qualquer página, inclusive no produto e na
  // /cart, onde o pop-up não sai: o link vem do rodapé): 180 (vipDeveAbrir). O registro é relido a
  // cada tentativa (outra aba pode ter fechado). Sem localStorage, abre uma vez por visita: marca no sessionStorage e,
  // sem ele também, quem chegou de outra página da loja já teve a vez. O botão redondo abre quando a pessoa quiser.
  const vip = document.getElementById('vl-vip');
  const grupo = document.querySelector('#vl-vip a[href], .vl-rodape__vip a[href]')?.href;
  const corpo = document.body.classList;
  if (grupo) {
    let registro = null, esperando = false;
    const ler = () => {
      let s;
      try { s = localStorage.getItem('vl-vip'); } catch { return registro; } // sem storage: o que esta página guardou
      try { return JSON.parse(s); } catch { return null; }
    };
    const gravar = motivo => {
      registro = { motivo, em: Date.now() };
      try { localStorage.setItem('vl-vip', JSON.stringify(registro)); } catch {}
    };
    const jaNaVisita = () => {
      try { localStorage.getItem('vl-vip'); return false; } catch {}
      try { return sessionStorage.getItem('vl-vip') === '1'; } catch {}
      try { return new URL(document.referrer).origin === location.origin; } catch { return false; }
    };
    registro = ler();
    document.addEventListener('click', e => { if (e.target.closest('a')?.href === grupo) gravar('entrou'); });
    // Quem já entrou no grupo e fecha o pop-up continua com os 180 dias.
    vip?.addEventListener('close', () => { if (registro?.motivo !== 'entrou' || vipDeveAbrir(Date.now(), registro)) gravar('fechou'); });
    const outro = () => document.querySelector('dialog[open]') || ('showPopover' in HTMLElement.prototype ? document.querySelector(':popover-open') : null);
    const tentar = () => {
      registro = ler();
      if (vip.open || !vipDeveAbrir(Date.now(), registro) || jaNaVisita()) return;
      const o = outro();
      if (!o && !document.hidden) {
        try { sessionStorage.setItem('vl-vip', '1'); } catch {}
        vip.showModal();
        return vip.focus(); // foco no card (tabindex=-1), não no X: no X o Chrome desenhava o contorno de foco ao abrir sozinho (20/10)
      }
      if (esperando) return; // a segunda tentativa também deu de cara com algo aberto: desiste até a próxima visita
      esperando = true;
      if (document.hidden) document.addEventListener('visibilitychange', tentar, { once: true });
      else o.addEventListener(o.matches('dialog') ? 'close' : 'toggle', tentar, { once: true });
    };
    const contar = () => setTimeout(tentar, 1200);
    if (!vip || window.Shopify?.designMode) {
      // sem o pop-up (produto e /cart) fica só o registro do clique; e o editor de tema não pode ganhar um pop-up por cima
    } else if (corpo.contains('vl-pagina-index')) {
      if (document.readyState === 'complete') contar(); else addEventListener('load', contar, { once: true });
    } else {
      const gatilhos = ['wheel', 'pointerdown', 'keydown']; // não 'scroll': a rolagem que o navegador restaura sozinho não é da pessoa
      const primeira = () => { for (const t of gatilhos) removeEventListener(t, primeira); contar(); };
      for (const t of gatilhos) addEventListener(t, primeira, { passive: true });
    }
  }

  // Painéis do desktop: com mouse, abrem ao passar (120 ms de intenção; fecham 200 ms depois de sair do botão e do
  // painel) e o clique leva pra página da categoria (o href do gêmeo <a>; pedido do Rafael, 20/10). Toque e teclado
  // abrem o painel no clique (popovertarget, sem JS). O painel da conta (#vl-conta) só abre e fecha no clique: com ele
  // aberto o hover do menu não faz nada, senão o mouse que desce do ícone até Pedidos fecharia a conta ao cruzar
  // a linha do menu (de 1024 a uns 1200 px). A foto troca com a marca em foco, mouse ou teclado; o par de fotos
  // de cada marca vem hidden do Liquid pra não baixar todas as fotos ao abrir o painel.
  if ('showPopover' in HTMLElement.prototype) {
    const mouse = matchMedia('(hover: hover) and (pointer: fine)');
    const comMouse = e => e.pointerType === 'mouse' && mouse.matches;
    let espera;
    const fechar = () => {
      clearTimeout(espera);
      espera = setTimeout(() => { for (const m of document.querySelectorAll('.vl-menu:popover-open:not(#vl-conta)')) m.hidePopover(); }, 200);
    };
    const trocar = (m, k) => {
      const pares = [...m.querySelectorAll('.vl-menu__par')];
      const alvo = pares.find(p => p.dataset.foto === k) || pares.find(p => p.dataset.foto === 'categoria');
      for (const p of pares) {
        if (p === alvo && p.hidden) { p.hidden = false; void p.offsetWidth; } // entra com o fade do CSS
        p.classList.toggle('is-on', p === alvo);
      }
    };
    for (const b of document.querySelectorAll('.vl-header__nav > *')) {
      const m = b.hasAttribute('data-painel') && document.getElementById(b.getAttribute('popovertarget'));
      b.addEventListener('pointerenter', e => {
        if (!comMouse(e) || document.querySelector('#vl-conta:popover-open')) return;
        if (!m) return fechar();
        clearTimeout(espera);
        espera = setTimeout(() => { if (!m.matches(':popover-open')) m.showPopover(); }, 120);
      });
      b.addEventListener('pointerleave', e => { if (comMouse(e)) fechar(); });
      if (!m) continue;
      // e.detail 0 = clique pelo teclado (Enter ou espaço): abre o painel como antes.
      b.addEventListener('pointerdown', e => { b.dataset.tipo = e.pointerType; });
      b.addEventListener('click', e => {
        if (!e.detail || b.dataset.tipo !== 'mouse' || !mouse.matches) return;
        e.preventDefault();
        const url = b.previousElementSibling.href;
        if (e.metaKey || e.ctrlKey) open(url); else location.href = url;
      });
      m.addEventListener('pointerenter', () => clearTimeout(espera));
      m.addEventListener('pointerleave', e => { if (comMouse(e)) fechar(); });
      m.addEventListener('toggle', e => {
        b.classList.toggle('is-aberto', e.newState === 'open');
        if (e.newState === 'open') trocar(m, 'categoria');
      });
      for (const t of ['pointerover', 'focusin']) {
        m.addEventListener(t, e => {
          const a = e.target.closest('.vl-menu__marcas a');
          if (a) trocar(m, a.dataset.foto || 'categoria');
        });
      }
    }
  }

  // Busca: o exemplo do campo troca entre as marcas da loja (parado com movimento reduzido) e a lista vem da busca
  // preditiva da Shopify em JSON, 200 ms depois da última tecla. Pedido velho é cancelado; erro de rede esconde a lista
  // e o Enter continua indo pra página de busca.
  // Peça que falta no markup não lança (o vl.js é um módulo só: um TypeError aqui pararia a sacola e o produto). Sem
  // uma das peças da lista, a busca fica só com o Enter pra página de busca.
  const busca = document.querySelector('[data-vl-busca]');
  const campo = busca?.querySelector('input[name="q"]');
  const res = busca?.querySelector('.vl-busca__resultados');
  const lista = busca?.querySelector('[data-vl-busca-lista]');
  const vazio = busca?.querySelector('[data-vl-busca-vazio]');
  const status = busca?.querySelector('[data-vl-busca-status]');
  const modelo = busca?.querySelector('[data-vl-busca-modelo]')?.content?.firstElementChild;
  if (campo && res && lista && vazio && status && modelo) {
    const pct = Number(document.documentElement.dataset.pixPct) || 0;
    let espera, pedido;

    const item = p => {
      const li = modelo.cloneNode(true);
      li.querySelector('a').href = p.url;
      const f = p.featured_image, img = li.querySelector('img');
      if (f && f.url) {
        const u = new URL(f.url, location.href);
        u.searchParams.set('width', '160');
        img.src = u.href;
        if (f.aspect_ratio) img.height = Math.round(160 / f.aspect_ratio);
      }
      li.querySelector('[data-marca]').textContent = p.vendor;
      li.querySelector('[data-nome]').textContent = p.title;
      li.querySelector('[data-preco]').textContent = status.dataset.pix.replace('{valor}', reais(pixCentavos(p.price, pct)));
      return li;
    };

    const buscar = async () => {
      const q = campo.value.trim();
      pedido?.abort();
      if (!q) { res.hidden = true; status.textContent = ''; return; }
      pedido = new AbortController();
      try {
        const r = await fetch(urlBusca(busca.dataset.vlBusca, q), { signal: pedido.signal, headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error(String(r.status));
        const produtos = (await r.json()).resources?.results?.products || [];
        const n = produtos.length;
        lista.replaceChildren(...produtos.map(item));
        res.hidden = false;
        vazio.hidden = n > 0;
        status.textContent = n === 0 ? status.dataset.nenhum : n === 1 ? status.dataset.um : status.dataset.varios.replace('{n}', n);
      } catch (e) {
        if (e.name !== 'AbortError') { res.hidden = true; status.textContent = ''; }
      }
    };
    campo.addEventListener('input', () => { clearTimeout(espera); espera = setTimeout(buscar, 200); });
  }
  if (campo) {
    const dica = busca.querySelector('.vl-busca__dica');
    const txt = dica?.firstElementChild;
    const marcas = txt ? (dica.dataset.marcas || '').split('|').filter(Boolean) : [];
    if (marcas.length > 1 && !calmo.matches) {
      busca.classList.add('is-viva');
      let i = 0;
      setInterval(() => {
        if (!busca.open || campo.value) return;
        txt.classList.remove('is-entra');
        txt.classList.add('is-sai');
        txt.addEventListener('animationend', () => {
          i = (i + 1) % marcas.length;
          txt.textContent = marcas[i];
          txt.classList.replace('is-sai', 'is-entra');
        }, { once: true });
      }, 2600);
    }
  }

  // Sacola (Tarefa 18). Cada POST no carrinho já pede a gaveta renderizada (Section Rendering API): uma ida só.
  // Fechar é nativo (X, Esc e o clique fora do closedby="any", com o conserto do Safari lá em cima).
  const gaveta = document.querySelector('[data-vl-gaveta]');
  const corpoDe = html => (html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-vl-gaveta-corpo]') : null);

  // Recomendados na sacola (Tarefa 18b): a faixa vem da seção vl-gaveta-recomendados (rota de recomendações, Section
  // Rendering) só com a gaveta aberta, ao abrir e a cada corpo novo com ela aberta (o produto da última peça pode ter
  // mudado). Sem recomendação, ou com erro, o lugar some.
  async function recomendar() {
    const lugar = gaveta?.open && gaveta.querySelector('[data-vl-rec]:not([aria-busy])');
    if (!lugar) return;
    lugar.setAttribute('aria-busy', 'true'); // um pedido por lugar
    let novo = null;
    try {
      const r = await fetch(lugar.dataset.vlRec);
      if (r.ok) novo = new DOMParser().parseFromString(await r.text(), 'text/html').querySelector('.vl-rec');
    } catch {}
    if (novo) { novo.dataset.vlRecDe = lugar.dataset.vlRec; lugar.replaceWith(novo); } else lugar.remove();
  }
  const abrirGaveta = () => { if (!gaveta.open) gaveta.showModal(); recomendar(); };

  // Troca o corpo da sacola (na gaveta ou na /cart), o "N itens" do título e a contagem do cabeçalho (vazia com a
  // sacola vazia; o número pula). Sem o corpo na resposta (seção null ou outro HTML) não lança: recarrega, porque o
  // carrinho já mudou no servidor.
  // ponytail: se a loja não renderizar a seção (Passo 5 da Tarefa 18), o plano troca pelo template cart.gaveta.
  // geracao conta as trocas: o redesenhar() que voltou depois de outra troca descarta a resposta velha.
  let geracao = 0;
  function trocarGaveta(html) {
    geracao++;
    const novo = corpoDe(html), atual = document.querySelector('[data-vl-gaveta-corpo]');
    if (!novo || !atual) return location.reload();
    // Os recomendados do mesmo produto (a quantidade mudou, ou saiu outra peça) passam pro corpo novo, sem piscar.
    const lugar = novo.querySelector('[data-vl-rec]'), rec = atual.querySelector('.vl-rec[data-vl-rec-de]');
    if (lugar && rec?.dataset.vlRecDe === lugar.dataset.vlRec) lugar.replaceWith(rec);
    atual.replaceWith(novo);
    recomendar();
    const qtd = gaveta?.querySelector('[data-vl-qtd-texto]');
    if (qtd) qtd.textContent = novo.dataset.itens || '';
    for (const c of document.querySelectorAll('[data-vl-contagem]')) {
      const n = novo.dataset.contagem || '';
      if (c.textContent.trim() === n) continue;
      c.textContent = n;
      c.classList.remove('is-pulo');
      void c.offsetWidth;
      c.classList.add('is-pulo');
    }
  }

  // A sacola desenhada com o carrinho de antes (Tarefa 18b, rodada 1). A Shopify muda a chave de cada linha (item.key)
  // quando o desconto do carrinho muda, e o Remover com a chave velha dá 400. Acontece sempre na volta do checkout do
  // Pix: a página vem desenhada com o atributo do app Scala em 1 (data-vl-scala) e o app volta ele pra 0 logo depois.
  // Então: espera o app (até 4 s) e redesenha a sacola pela seção vl-gaveta, na gaveta ou na /cart. O Remover que dá
  // erro também redesenha, pro "Tente de novo" valer. Sem rede, fica como está.
  async function redesenhar() {
    const g = geracao;
    try {
      const r = await fetch(`${location.pathname}?sections=vl-gaveta`); // sem Accept: JSON (no produto, viraria o JSON do produto)
      const html = r.ok ? (await r.json())['vl-gaveta'] : null;
      if (html && g === geracao) trocarGaveta(html); // outra troca chegou antes: esta resposta é mais velha que a sacola
    } catch {}
  }
  const velha = document.querySelector('[data-vl-gaveta-corpo][data-vl-scala]');
  if (velha) (async () => {
    for (let i = 0; i < 8; i++) {
      await new Promise(ok => setTimeout(ok, 500));
      const c = await fetch(velha.dataset.vlScala).then(r => r.json()).catch(() => null);
      if (c && c.attributes?._scaladiscount !== '1') return redesenhar();
    }
  })();

  async function postar(url, corpo) {
    const r = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...corpo, sections: ['vl-gaveta'], sections_url: location.pathname }),
    });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || String(r.status));
    trocarGaveta(j.sections?.['vl-gaveta']);
  }

  // Remover e quantidade (menos e mais, Tarefa 18c), na gaveta e na /cart: uma troca por vez (o clique duplo e o clique
  // noutra linha esperam a resposta). A linha removida sai de lado enquanto o pedido roda. Deu certo: o anúncio discreto
  // lê a quantidade nova (data-qtd do anúncio, com {n}) e o total novo, e o foco volta pro mesmo botão da mesma linha (pela chave; se ela mudou, pela variante), ou pro
  // outro botão se esse desligou (no 1 e no 10), ou pro primeiro Remover, ou pro link da sacola vazia. Erro: o aviso no
  // topo e a sacola redesenhada antes de soltar a trava (a chave pode ter mudado com o desconto do carrinho, 18b).
  // Acima do estoque, a linha inteira vai pra Encomenda: é o Liquid (vl-estado) que agrupa, na volta.
  let trocando = false;
  // sel: o botão da mesma linha que fica com o foco (null: o primeiro Remover)
  const focar = (chave, sel) => {
    const novo = document.querySelector('[data-vl-gaveta-corpo]');
    const itens = [...(novo?.querySelectorAll('.vl-item') || [])];
    const mesma = sel && (itens.find(x => x.dataset.vlChave === chave) || itens.find(x => x.dataset.vlChave?.split(':')[0] === chave.split(':')[0]));
    ((mesma && (mesma.querySelector(`${sel}:not(:disabled)`) || mesma.querySelector('[data-vl-passo]:not(:disabled)')))
      || novo?.querySelector('[data-vl-linha]') || novo?.querySelector('.vl-gaveta__vazia a'))?.focus();
  };
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-vl-linha], [data-vl-passo]');
    const corpo = b?.closest('[data-vl-gaveta-corpo]');
    if (!corpo?.dataset.change) return;
    e.preventDefault(); // sem JS: o Remover é o link nativo do /cart/change; o menos e o mais dão lugar ao campo e ao Atualizar
    if (trocando) return;
    trocando = true;
    corpo.setAttribute('aria-busy', 'true');
    const aviso = document.querySelector('[data-vl-gaveta-erro]');
    const anuncio = document.querySelector('[data-vl-anuncio]');
    if (aviso) aviso.textContent = '';
    const li = b.closest('.vl-item');
    const chave = li?.dataset.vlChave || b.dataset.vlLinha;
    const passo = Number(b.dataset.vlPasso) || 0;
    const sel = passo ? `[data-vl-passo="${passo}"]` : null;
    if (!passo) li?.classList.add('is-saindo');
    try {
      const pedido = passo ? pedidoQuantidade(chave, li.dataset.vlQtd, passo, li.dataset.vlMax) : pedidoRemover(chave);
      await postar(corpo.dataset.change, pedido);
      const novo = document.querySelector('[data-vl-gaveta-corpo]');
      const soma = novo?.querySelector('.vl-gaveta__soma');
      const total = soma ? [...soma.children].map(x => x.textContent.trim()).join(' ') : (novo?.querySelector('.vl-gaveta__vazia p')?.textContent.trim() || '');
      if (anuncio) anuncio.textContent = passo ? `${(anuncio.dataset.qtd || '').replace('{n}', pedido.quantity)} ${total}`.trim() : total;
      focar(chave, sel);
    } catch {
      li?.classList.remove('is-saindo');
      if (aviso) aviso.textContent = passo ? aviso.dataset.qtd : aviso.dataset.remover;
      await redesenhar(); // a chave pode ter mudado (desconto do carrinho mudou depois do desenho)
      focar(chave, sel || '[data-vl-linha]'); // o foco não se perde no corpo novo: volta pro mesmo botão da mesma linha
    } finally {
      trocando = false;
      corpo.removeAttribute('aria-busy');
    }
  });

  if (gaveta) {
    for (const a of document.querySelectorAll('[data-vl-abrir-gaveta]')) {
      a.addEventListener('click', e => { e.preventDefault(); abrirGaveta(); });
    }
  }

  // Produto (Tarefa 19). O Liquid manda o botão ligado (a compra nativa funciona sem JS ou com o JS quebrado; o CSS dá
  // a cara de desligado enquanto nenhum tamanho está marcado) e o atualizar() desliga na carga: com JS, o botão fica
  // desligado até escolher o tamanho ("Escolha o tamanho", como o mockup). Sem os textos o JS não liga o formulário;
  // sem a linha do prazo ou a caixa de erro, a página só não escreve nelas.
  const form = document.querySelector('[data-vl-produto]');
  const t = lerTextos(form?.querySelector('[data-vl-textos]'));
  if (form && t) {
    const linha = form.querySelector('[data-vl-prazo]');
    const nota = form.querySelector('[data-vl-nota]');
    const falha = form.querySelector('[data-vl-erro]');
    const dizer = s => { if (linha) linha.textContent = s || ''; };
    // O erro aparece na barra de compra (no celular a linha do prazo pode estar fora da tela).
    const errar = on => { if (falha) falha.hidden = !on; else if (on) dizer(t.erro); };
    const botoes = form.querySelectorAll('[data-vl-comprar]');
    const wa = document.querySelector('[data-vl-whatsapp]');
    const marcado = () => form.querySelector('input[name="id"]:checked');
    form.noValidate = true;

    function atualizar() {
      const r = marcado();
      const algum = form.querySelector('input[name="id"]:not(:disabled)');
      const s = escolherTamanho(r ? r.dataset.estado : (algum ? null : 'indisponivel'), t);
      dizer(s.linha);
      if (nota) nota.textContent = (s.acao === 'comprar' && r.dataset.nota) || '';
      // innerHTML: o rótulo vem do locale do tema (adicionar_html: "Adicionar" + " à sacola", que some no celular).
      for (const b of botoes) { b.innerHTML = s.rotulo; b.dataset.acao = s.acao; b.disabled = s.acao !== 'comprar'; }
      if (wa && t.whatsapp) {
        wa.href = linkWhatsapp(wa.dataset.numero, t.whatsapp, {
          produto: wa.dataset.produto,
          cor: wa.dataset.cor,
          tamanho: r ? r.dataset.tamanho : '',
          encomenda: r ? r.dataset.estado === 'encomenda' : false,
          url: r ? `${wa.dataset.url}?variant=${r.value}` : wa.dataset.url,
        });
      }
    }

    form.addEventListener('change', () => { errar(false); atualizar(); });
    form.addEventListener('submit', async e => {
      if (!gaveta) return; // sem a gaveta, POST nativo pro /cart/add
      e.preventDefault();
      const r = marcado();
      if (!r || form.hasAttribute('aria-busy') || (e.submitter || botoes[0])?.dataset.acao !== 'comprar') return;
      form.setAttribute('aria-busy', 'true');
      errar(false);
      for (const b of botoes) { b.disabled = true; b.classList.add('is-carregando'); b.textContent = t.adicionando || b.textContent; }
      // Só o POST fica no try: um erro ao abrir a gaveta não vira "não deu pra adicionar" com o item já na sacola.
      let ok = false;
      try {
        await postar(gaveta.dataset.add, { items: [{ id: Number(r.value), quantity: 1 }] });
        ok = true;
      } catch {}
      form.removeAttribute('aria-busy');
      for (const b of botoes) b.classList.remove('is-carregando');
      atualizar();
      if (!ok) errar(true);
      else abrirGaveta();
    });
    atualizar();
  }

  // Galeria (desktop): a miniatura ativa acompanha a foto que cruza a linha a 40% da altura da tela; o clique é a
  // âncora #vl-foto-N (sem JS, a primeira fica marcada). A miniatura do vídeo leva até ele e dá o play (foi o cliente
  // que pediu, então vale com movimento reduzido). O vídeo para quando sai da tela.
  const galeria = document.querySelector('.vl-galeria');
  if (galeria && 'IntersectionObserver' in window) {
    const minis = [...galeria.querySelectorAll('.vl-galeria__miniaturas a')];
    const espia = new IntersectionObserver(es => {
      for (const e of es) {
        if (!e.isIntersecting) continue;
        for (const a of minis) {
          if (a.hash === `#${e.target.id}`) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        }
      }
    }, { rootMargin: '-40% 0px -59% 0px' });
    if (minis.length) for (const f of galeria.querySelectorAll('.vl-galeria__foto')) espia.observe(f);
    for (const a of minis) a.addEventListener('click', () => document.getElementById(a.hash.slice(1))?.querySelector('video')?.play().catch(() => {}));
    for (const v of galeria.querySelectorAll('video')) {
      new IntersectionObserver(([e]) => { if (!e.isIntersecting && !v.paused) v.pause(); }).observe(v);
    }
  }

  // Coluna da direita presa (desktop): a altura dela vai pro CSS (--alto). Mais alta que a tela, ela rola até o fim
  // aparecer e prende embaixo.
  const info = document.querySelector('.vl-produto__info');
  if (info && 'ResizeObserver' in window) new ResizeObserver(() => info.style.setProperty('--alto', `${info.offsetHeight}px`)).observe(info);

  // Abas (Descrição, Prazo de entrega, Trocas e reembolso): clique, ou setas, Home e End com o foco na aba.
  for (const lista of document.querySelectorAll('[role="tablist"]')) {
    const abas = [...lista.querySelectorAll('[role="tab"]')];
    const ativar = aba => {
      for (const a of abas) {
        const on = a === aba;
        a.setAttribute('aria-selected', on);
        a.tabIndex = on ? 0 : -1;
        const p = document.getElementById(a.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      }
    };
    abas.forEach((a, i) => {
      a.addEventListener('click', () => ativar(a));
      a.addEventListener('keydown', e => {
        const j = abaPelaTecla(i, e.key, abas.length);
        if (j < 0) return;
        e.preventDefault();
        ativar(abas[j]);
        abas[j].focus();
      });
    });
  }

  // Você também pode gostar: a seção vl-relacionados (peças da mesma categoria, pela URL do produto) chega quando a
  // faixa chega perto da tela. Sem peça (ou com erro), a faixa some.
  const rel = document.querySelector('[data-vl-relacionados]');
  if (rel) {
    const carregar = async () => {
      try {
        const r = await fetch(rel.dataset.vlRelacionados);
        if (!r.ok) throw new Error(String(r.status));
        const novo = new DOMParser().parseFromString(await r.text(), 'text/html').querySelector('.vl-relacionados');
        if (novo) rel.replaceWith(novo); else rel.remove();
      } catch {
        rel.remove();
      }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); carregar(); } }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(rel);
    } else carregar();
  }

  // Home (Tarefa 20). Topo: o zoom lento da foto (CSS) para quando o topo sai da tela.
  const topo = document.querySelector('.vl-hero');
  if (topo && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => topo.classList.toggle('is-fora', !e.isIntersecting)).observe(topo);
  }

  // Carrossel: o leque dos feedbacks (o Unboxing virou Stories, mais embaixo). Cada item ganha data-pos = posicao()
  // (o CSS desenha). Anda só com o cliente: botões, setas do teclado, deslize e clique num item de lado (traz ele pra
  // frente). Os de lado ficam fora do leitor de tela e do Tab; as falas ([data-fala], uma por item, na mesma ordem)
  // mostram só a da frente. Com 1 item não anda (o Liquid nem põe as setas).
  for (const raiz of document.querySelectorAll('[data-carrossel]')) {
    const itens = [...raiz.querySelectorAll('[data-item]')];
    const n = itens.length;
    const sec = raiz.closest('section');
    if (n < 2 || !sec) continue;
    const atual = sec.querySelector('[data-atual]');
    const status = sec.querySelector('[data-status]');
    const falas = [...sec.querySelectorAll('[data-fala]')];
    let frente = 0, arrastou = false, x0 = null, y0 = 0;
    const ir = d => {
      frente = (frente + d + n) % n;
      itens.forEach((c, j) => {
        const k = posicao(j, frente, n);
        c.dataset.pos = Math.max(-3, Math.min(3, k));
        if (k) c.setAttribute('aria-hidden', 'true'); else c.removeAttribute('aria-hidden');
        for (const f of c.querySelectorAll('button, a')) f.tabIndex = k ? -1 : 0;
      });
      falas.forEach((f, j) => {
        const on = j === frente;
        f.toggleAttribute('data-ativa', on);
        if (on) f.removeAttribute('aria-hidden'); else f.setAttribute('aria-hidden', 'true');
        for (const x of f.querySelectorAll('a, button')) x.tabIndex = on ? 0 : -1;
      });
      if (atual) atual.textContent = frente + 1;
      if (status && d) status.textContent = (raiz.dataset.statusTexto || '').replace('{n}', frente + 1).replace('{total}', n);
    };
    for (const b of sec.querySelectorAll(`[data-ir][aria-controls="${raiz.id}"]`)) b.addEventListener('click', () => ir(Number(b.dataset.ir)));
    raiz.addEventListener('keydown', e => {
      const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
      if (d) { e.preventDefault(); ir(d); }
    });
    raiz.addEventListener('pointerdown', e => { x0 = e.clientX; y0 = e.clientY; arrastou = false; });
    raiz.addEventListener('pointercancel', () => { x0 = null; });
    raiz.addEventListener('dragstart', e => e.preventDefault()); // com mouse, arrastar a imagem cancelava o gesto
    addEventListener('pointerup', e => { // na janela: com mouse, o soltar pode cair fora do carrossel
      if (x0 === null) return;
      const dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { arrastou = true; ir(dx < 0 ? 1 : -1); }
    });
    // Na captura: o deslize não abre nada, e o clique num item de lado só traz ele pra frente.
    raiz.addEventListener('click', e => {
      if (arrastou) { e.preventDefault(); arrastou = false; return; }
      const c = e.target.closest('[data-item]');
      const k = c ? posicao(itens.indexOf(c), frente, n) : 0;
      if (k) { e.preventDefault(); ir(k); }
    }, true);
    ir(0);
  }

  // Cartaz dos vídeos (data-poster): o poster= do HTML baixaria na primeira carga mesmo com preload="none". Aqui os
  // cartazes do Unboxing entram juntos quando a faixa chega a 400px da tela, como os relacionados (os escondidos
  // aparecem depois, já com a capa). Sem IntersectionObserver, entram na hora.
  const capas = [...document.querySelectorAll('video[data-poster]')];
  const porCapas = alvo => {
    for (const v of capas) if (v === alvo || alvo.contains(v)) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); }
  };
  const alvos = new Set(capas.map(v => v.closest('[data-stories]') || v));
  if (alvos.size && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => {
      for (const e of es) if (e.isIntersecting) { io.unobserve(e.target); porCapas(e.target); }
    }, { rootMargin: '0px 0px 400px 0px' });
    for (const a of alvos) io.observe(a);
  } else for (const a of alvos) porCapas(a);

  // Unboxing em Stories (Tarefa 20b). Um vídeo por vez (os outros hidden); a barrinha do atual enche enquanto ele toca
  // (--p, de 0 a 1, a cada quadro), as anteriores cheias e as próximas vazias. Toque na metade direita passa, na esquerda
  // volta, deslizar também; setas do teclado e os botões da legenda fazem o mesmo. Acabou, vem o próximo (o último volta
  // pro primeiro; com 1 vídeo ele repete). Toca mudo só com a faixa na tela (metade dela). Tocar no vídeo parado toca:
  // com movimento reduzido nada toca sozinho (fica a capa, e a pausa começa pressionada), e quando um acaba vem a capa
  // do próximo, parada. O mesmo quando o navegador recusa o autoplay (iPhone em pouca energia). A pausa para e volta;
  // o leitor de tela ouve "Vídeo N de M" só quando o cliente troca. Sem JS, fica o primeiro vídeo com os controles.
  const stories = document.querySelector('[data-stories]');
  const sv = stories ? [...stories.querySelectorAll('video')] : [];
  const sec = stories?.closest('section');
  if (sv.length && sec && 'IntersectionObserver' in window) {
    const itens = [...stories.querySelectorAll('[data-item]')];
    const barras = [...stories.querySelectorAll('[data-barra]')];
    const falas = [...sec.querySelectorAll('[data-fala]')];
    const atual = sec.querySelector('[data-atual]');
    const status = sec.querySelector('[data-status]');
    const pausa = sec.querySelector('[data-pausa]');
    const n = sv.length;
    let i = 0, naTela = false, parado = calmo.matches, eu = false, quadro = 0;
    const encher = (k, p) => barras[k]?.style.setProperty('--p', p);
    const andar = () => {
      const v = sv[i];
      if (v.duration) encher(i, v.currentTime / v.duration);
      quadro = v.paused ? 0 : requestAnimationFrame(andar);
    };
    const marcar = () => pausa?.setAttribute('aria-pressed', parado); // o rótulo fica "Pausar os vídeos"; pressionado = parado
    const parar = v => { if (!v.paused) { eu = true; v.pause(); } };
    const tocar = () => {
      if (parado || !naTela) return;
      sv[i].muted = true;
      sv[i].play().catch(e => { if (e.name === 'NotAllowedError') { parado = true; marcar(); } }); // autoplay recusado: fica a capa, o toque toca
    };
    const ir = (d, cliente) => {
      parar(sv[i]);
      i = (i + d + n) % n;
      itens.forEach((it, k) => { it.hidden = k !== i; });
      barras.forEach((b, k) => encher(k, k < i ? 1 : 0));
      falas.forEach((f, k) => {
        const on = k === i;
        f.toggleAttribute('data-ativa', on);
        if (on) f.removeAttribute('aria-hidden'); else f.setAttribute('aria-hidden', 'true');
        for (const x of f.querySelectorAll('a, button')) x.tabIndex = on ? 0 : -1;
      });
      if (atual) atual.textContent = i + 1;
      if (cliente && status) status.textContent = (stories.dataset.statusTexto || '').replace('{n}', i + 1).replace('{total}', n);
      if (parado || !naTela) sv[i].load(); // não vai tocar agora: o load() volta a capa
      else sv[i].currentTime = 0;
      tocar();
    };
    sv.forEach((v, k) => {
      v.controls = false; // o Liquid manda com controls pra quem está sem JS
      if (n < 2) v.loop = true;
      v.addEventListener('play', () => {
        if (k !== i) return;
        if (parado) { parado = false; marcar(); }
        cancelAnimationFrame(quadro);
        andar();
      });
      v.addEventListener('pause', () => { if (!eu && !v.ended && k === i) { parado = true; marcar(); } eu = false; });
      v.addEventListener('ended', () => {
        if (k !== i) return;
        if (calmo.matches) { parado = true; marcar(); }
        ir(1);
      });
    });
    for (const b of sec.querySelectorAll('[data-ir][aria-controls="vl-videos"]')) b.addEventListener('click', () => ir(Number(b.dataset.ir), true));
    stories.addEventListener('keydown', e => {
      const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
      if (d && n > 1) { e.preventDefault(); ir(d, true); }
    });
    let x0 = null, y0 = 0, arrastou = false;
    stories.addEventListener('pointerdown', e => { x0 = e.clientX; y0 = e.clientY; arrastou = false; });
    stories.addEventListener('pointercancel', () => { x0 = null; });
    addEventListener('pointerup', e => { // na janela: com mouse, o soltar pode cair fora do vídeo
      if (x0 === null) return;
      const dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (n > 1 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { arrastou = true; ir(dx < 0 ? 1 : -1, true); }
    });
    stories.addEventListener('click', e => {
      if (arrastou) { arrastou = false; return; }
      if (sv[i].paused) { parado = false; naTela = true; marcar(); tocar(); return; }
      if (n < 2) return;
      const r = stories.getBoundingClientRect();
      ir(e.clientX - r.left < r.width / 2 ? -1 : 1, true);
    });
    pausa?.addEventListener('click', () => {
      parado = !parado;
      marcar();
      if (parado) parar(sv[i]);
      else { naTela = true; tocar(); } // tocar pelo botão vale mesmo com movimento reduzido: foi o cliente
    });
    new IntersectionObserver(([e]) => {
      naTela = e.intersectionRatio >= 0.5; // o 0 avisa a saída mesmo quando o play foi dado com menos da metade na tela
      if (naTela) tocar(); else parar(sv[i]);
    }, { threshold: [0, 0.5] }).observe(stories);
    marcar();
  }

  // Entrada ao rolar (Prazos e Categorias): o normal é o visível. Só o bloco que ainda está abaixo da tela quando a
  // página abre ganha a entrada (.is-revelando, CSS), uma vez, quando chega a 10% da borda de baixo. Sem
  // IntersectionObserver ou com movimento reduzido: tudo parado e visível.
  const revela = document.querySelectorAll('[data-revela]');
  if (revela.length && !calmo.matches && 'IntersectionObserver' in window) {
    const vistos = new WeakSet();
    const io = new IntersectionObserver(es => {
      for (const e of es) {
        const primeira = !vistos.has(e.target);
        vistos.add(e.target);
        if (!e.isIntersecting) continue;
        io.unobserve(e.target);
        if (!primeira) e.target.classList.add('is-revelando');
      }
    }, { rootMargin: '0px 0px 10% 0px' });
    for (const el of revela) io.observe(el);
  }
}
